export const STATUS_REQUEST = [
  {
    id: 27,
    name: 'Nuevo',
    progress: 0,
    key: 'new',
    color: '#FFD700',
    nextStatus: [
      {
        id: 28,
        name: 'Revisado',
        key: 'reviewed',
      },
    ],
  },
  {
    id: 28,
    name: 'Revisado',
    progress: 50,
    key: 'reviewed',
    color: '#FFA500',
    nextStatus: [
      {
        id: 29,
        name: 'Seguimiento finalizado',
        key: 'in_process',
      },
    ],
  },
  {
    id: 29,
    name: 'Seguimiento finalizado',
    progress: 75,
    key: 'in_process',
    color: '#FF7F50',
    nextStatus: [
      {
        id: 30,
        name: 'Finalizado',
        key: 'finished',
      },
      {
        id: 31,
        name: 'Negado',
        key: 'denied',
      },
      {
        id: 32,
        name: 'Duplicado',
        key: 'duplicated',
      },
    ],
  },
  {
    id: 30,
    name: 'Finalizado',
    progress: 100,
    key: 'finished',
    color: '#32CD32',
  },
  {
    id: 31,
    name: 'Negado',
    progress: 100,
    key: 'denied',
    color: '#DC143C',
  },
  {
    id: 32,
    name: 'Duplicado',
    progress: 100,
    key: 'duplicated',
    color: '#FF0000',
  },
]
